import { Options } from "@angular-slider/ngx-slider";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Carousel } from "primeng/carousel";
import { ImageGalleryModalComponent } from "src/app/shared/components/image-gallery-modal/image-gallery-modal.component";
import { ApiService } from "src/app/shared/services";
import { EnvService } from "src/app/shared/services/env.service";

@Component({
  selector: "app-project-details",
  templateUrl: "./project-details.component.html",
  styleUrls: ["./project-details.component.less"],
})
export class ProjectDetailsComponent implements OnInit, AfterViewInit {
  currentPage = 8;
  isHandset = false;
  logoPath: any;
  homeList: { name: string; image: string; value: string }[];
  stageList: { name: string; image: string; value: string }[];
  location = "";
  home_type = "";
  people = "";
  household = "";
  priority = "";
  stage = "";
  budgetValue: number = 2;

  budgetOptions: Options = {
    showTicksValues: true,
    stepsArray: [
      {
        value: 1,
        legend: `
        <div class="c-grey">|</div>
        
        <div class="f-20">$2,500 <br/> or less</div>`,
      },

      {
        value: 2,
        legend: `
        <div class="c-grey">|</div>
      
      <div class="f-20">$5,000</div>`,
      },

      {
        value: 3,
        legend: `
        <div class="c-grey">|</div>
      
      <div class="f-20">$7,500</div>`,
      },
      {
        value: 4,
        legend: `
        <div class="c-grey">|</div>
        
        <div class="f-20">$10,000 <br/> or more</div>`,
      },
    ],
  };
  adults_count: number;
  children_count: number;
  pets: string[] = [];

  petsList: any[] = [
    { name: "None", disable: false },
    { name: "Dogs", disable: false },
    { name: "Cats", disable: false },
    { name: "Other", disable: false },
  ];

  roomId: any;
  quizId: string;
  lowEnd: string;
  highEnd: string;
  designerGallery: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  portfolioGallery: any[] = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  designerList: any[] = [];
  currentItem: any;
  utmDesigner: any;
  imageLoadState: { [key: string]: boolean } = {};
  deviceWidth: number;
  designerSelection: any;
  paymentRequired: boolean = true;
  userProfile: any;
  userProfileId: any;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private env: EnvService,
    private router: Router,
    private api: ApiService,
    private actRouter: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private matDialog: MatDialog,
    private snackbar: MatSnackBar,
  ) {
    this.quizId = this.api.quizId;
    this.logoPath = this.env.logoPathBlack;
    Carousel.prototype.onTouchMove = () => { };


  }
  @HostListener("window:resize")
  onWindowResize() {
    this.deviceWidth = window.innerWidth;
  }


  onImageLoad(imageSrc: string) {
    this.imageLoadState[imageSrc] = true;
  }

  ngOnInit(): void {
    this.roomId = this.actRouter.snapshot.params.bookingId;

    this.actRouter.queryParams.subscribe(params => {
      this.utmDesigner = params['utm_designer'] || null;
      console.log('UTM Designer:', this.utmDesigner);
    });

    this.getUserProfiles()

    // if (this.roomId) {
    //   this.getDesignIntake();
    //   this
    // }
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isHandset = result.matches;
        if (this.isHandset) {
          this.budgetOptions = {
            vertical: true,
            showTicksValues: true,
            stepsArray: [
              {
                value: 1,
                legend: `
            
            <div class="f-20-mob">$2,500 <br/> or less</div>`,
              },

              {
                value: 2,
                legend: `
          
          <div class="f-20-mob">$5,000</div>`,
              },

              {
                value: 3,
                legend: `
          
          <div class="f-20-mob">$7,500</div>`,
              },
              {
                value: 4,
                legend: `
            
            <div class="f-20-mob">$10,000 <br/> or more</div>`,
              },
            ],
          };
        }
      });
    this.loadList();
  }

  currentUserProfile:any;
    selectedHomeProfile: any;

  setValues(data:any) {
    this.currentPage = 10;
    this.currentUserProfile = data;
           this.userProfile = this.currentUserProfile;
        this.userProfileId = this.currentUserProfile.user_profile_id;
        this.home_type = this.currentUserProfile.home_type;
        this.adults_count = this.currentUserProfile.adults_count;
        this.children_count = this.currentUserProfile.children_count;
        this.pets = this.currentUserProfile.pets ? this.currentUserProfile.pets.split(',') : [];
  }

  select(data) {
    this.selectedHomeProfile = data;
    this.currentPage = 12;
  }

  addNew() {
    this.currentPage = 10;
    this.home_type = '';
    this.adults_count = null;
    this.children_count = null;
    this.stage = '';
    this.budgetValue = 2;
    this.pets = [];
    this.userProfileId = null;

  }

  removeProfile(p) {
    const data ={"user_profile_id":p.user_profile_id}
    this.api.removeDesignHomeProfile(data).subscribe(res => {
      if (res) {
        this.snackbar.open('Home Profile removed', 'x', { duration: 4000 });
        this.getUserProfiles();
      }
    })
  }
  userProfileList: any[] = [];
  getUserProfiles() {
    this.api.getUserProfiles().subscribe((res: any) => {
      if (res && res.user_profile && res.user_profile[0]) {
        this.userProfileList = res.user_profile.filter(f=>f.is_active==1);
        this.currentPage = 9;
      } else {
        this.currentPage = 10;
      }
      this.getDesignIntake();
    }, err => {
      this.getDesignIntake();
      this.currentPage = 10;

    })
  }

  getDesignIntake() {

    this.api.getDesignIntake(this.roomId).subscribe((res: any[]) => {
      if (res && res.length > 0) {
        // if(res[0].status!=='01'){ 
        // } else if(res[0].status=='01')  {
        this.designerSelection = res[0].designer_selection;
        if (!this.userProfile) {
          this.home_type = res[0].home_type;
          this.adults_count = res[0].adults_count;
          this.children_count = res[0].children_count;
          this.pets = res[0].pets ? res[0].pets.split(',') : [];
        }
        this.stage = res[0].stage;
        this.budgetValue = res[0].project_budget === '2500'
          ? 1
          : res[0].project_budget === '5000'
            ? 2
            : res[0].project_budget === '7500'
              ? 3
              : res[0].project_budget === '10000'
                ? 4
                : 2;
        this.paymentRequired = res[0].payment_required;
        // }
        if (res[0].pets) { this.petChange({ value: this.pets[0] }) }
        this.getDesignProfile();
      } else {
        this.router.navigate(['/style-quiz'])
      }
    });
  }
  loadList() {
    this.homeList = [
      {
        name: "Urban House",
        image: this.env.assetBaseUrl + "site/quiz/034-duplex.png",
        value: "urban_home",
      },
      {
        name: "Apartment",
        value: "apartment",
        image: this.env.assetBaseUrl + "site/quiz/035-apartment.png",
      },
      {
        name: "Suburban House",
        value: "suburban_home",
        image: this.env.assetBaseUrl + "site/quiz/036-house.png",
      },
      {
        name: "Farmhouse/Lodge",
        image: this.env.assetBaseUrl + "site/quiz/037-farmhouse.png",
        value: "country",
      },
    ];
    this.stageList = [
      {
        name: "Empty Room",
        image: this.env.assetBaseUrl + "site/quiz/043-floor.png",
        value: "early",
      },
      {
        name: "Partially There",
        image: this.env.assetBaseUrl + "site/quiz/045-hotel.png",
        value: "midway",
      },
      {
        name: "Touch Ups/Refresh",
        image: this.env.assetBaseUrl + "site/quiz/044-room.png",
        value: "late",
      },
    ];
  }

   getHome(p) {
    if(p){
    return this.homeList.find(f => f.value === p.home_type)?.name
    } else {
      return '';
    }
  }
  get deviceHeight() {
    return window.innerHeight;
  }

  ngAfterViewInit(): void {
    this.hideIntercomIcon();
  }

  petChange(e: any) {
    console.log(this.pets, 'event')
    if (e.value.includes('None')) {
      this.pets = ['None'];
      this.petsList.forEach(f => {
        if (f.name !== 'None') {
          f.disable = true;
        }
      })
    } else {
      this.petsList.forEach(f => {
        if (f.name == 'None') {
          f.disable = true;
        } else {
          f.disable = false;

        }
      })
    }
    if (this.pets.length === 0) {
      this.petsList.forEach(f => {
        f.disable = false
      })
    }
    // if(this.pets)
  }

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);
  }

  goToPage13() {
    this.currentPage = 13;
  }
  goToPage12() {
    this.saveDesignHomeProfile();
    this.currentPage = 12;

  }
  goToPage14() {
    if (this.currentItem) {
      this.currentPage = 14;
    } else {
      this.savePref();
    }
  }

  selectLivingStyle(name, i) {
    if (this.currentPage === 10) {
      this.home_type = name;
      this.currentPage = 11;
    } else if (this.currentPage === 12) {
      this.stage = name;
      this.currentPage = 13;
    }
    window.scrollTo(0, 0);
  }


  savePref() {
    if (this.budgetValue === 1) {
      this.lowEnd = "0"; this.highEnd = "2500"
    } else if (this.budgetValue === 2) {
      this.lowEnd = "2500"; this.highEnd = "5000"
    } else if (this.budgetValue === 3) {
      this.lowEnd = "5000"; this.highEnd = "7500"
    } else if (this.budgetValue === 4) {
      this.lowEnd = "7500"; this.highEnd = "10000"
    }
    let obj = {
      project_budget:
        this.budgetValue === 1
          ? "2500"
          : this.budgetValue === 2
            ? "5000"
            : this.budgetValue === 3
              ? "7500"
              : this.budgetValue === 4
                ? "10000"
                : "0",
      room_id: this.roomId,
      userProfileId: this.selectedHomeProfile ? this.selectedHomeProfile.user_profile_id : this.userProfileId,
      stage: this.stage,
      designer_selection: this.utmDesigner ? this.utmDesigner :
        this.currentItem ? this.currentItem.designerId : ''
    };

    this.api.saveDesignIntake(obj).subscribe((resp) => {

      // this.updateBookingTask();
      if (this.paymentRequired) {
        this.router.navigate([`/design/book/payment`]);
      } else {
        this.router.navigate([`/design/rooms/landing`]);
      }
      // this.snackbar.open('Budget submitted successfully','x',{duration:6000})
    });

  }


  saveDesignHomeProfile() {
    let obj = {
      home_type: this.home_type,
      children_count: this.children_count,
      adults_count: this.adults_count,
      pets: this.pets ? this.pets : "",
      user_profile_id: this.userProfileId
    };

    this.api.saveDesignHomeProfile(obj).subscribe((resp: any) => {
      this.userProfileId = resp;
      // this.snackbar.open('Budget submitted successfully','x',{duration:6000})
    });
  }

  Back() {
    if(this.currentPage===9){
      this.router.navigate([`/style-quiz`]);

    }
    if (this.currentPage === 10) {
      this.router.navigate([`/style-quiz/my-style/${this.quizId}`]);
      // if (this.isLoggedIn) {
      //   this.currentPage = 7;
      // } else {
      //   this.currentPage = 8;
      // }
    } else {
      this.currentPage = this.currentPage - 1;
    }
  }
  next() {
    if (this.currentPage === 10 || this.currentPage === 12) {
      this.currentPage = this.currentPage + 1;
    }
    if (this.currentPage === 9) {
      this.currentPage = 14;
    }
  }


  error() {
    return `<div class="skeleton-load skeleton-text"></div>`
  }

  selectDesigner() {
    this.api.saveDesignIntake('').subscribe(resp => {
      if (resp) {
        //  this.router.navigate([`/design/book/payment/${this.roomId}`]);
        if (this.paymentRequired) {
          this.router.navigate([`/design/book/payment`]);
        } else {
          this.router.navigate([`/design/rooms/landing`]);
        }
      }
    })

  }

  getDesignProfile() {
    this.api.getDesignProfile().subscribe((res: any[]) => {
      this.designerList = res.filter(f => f.is_displayable == 1);
      if (this.designerList.length > 0) {
        if (this.designerSelection) {
          this.currentItem = this.designerList.find(f => f.designerId === this.designerSelection);
        } else {
          this.currentItem = this.designerList[0];
        }
      }
    });
  }

  @ViewChild('carousel') carousel!: Carousel;
  selectItem(data: any) {
    this.currentItem = JSON.parse(JSON.stringify(data));
    this.currentItem.portfolio = null;
    this.currentItem = null;
    setTimeout(() => {
      this.reset()
      this.currentItem = JSON.parse(JSON.stringify(data));
    }, 0);
  }

  reset() {
    if (this.carousel) {
      this.carousel.page = 0; // Manually reset the index to 0
      this.cdRef.detectChanges();
      // this.carousel.updateState(); // Ensure the UI updates
    }
  }
  openInsta(data) {
    window.open(data.social_ig, '_blank');
  }
  openGallery(e, images: any[]): void {
    e.stopPropagation();
    this.matDialog.open(ImageGalleryModalComponent, {
      data: { gallery: images },
      panelClass: 'custom-gallery-modal'
    });
  }

  get isLoggedIn(): boolean {
    return (
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user")).email.length > 0
    );
  }

sanitizeNumber(event: any, modelValue: string): string {
  let value = event.target.value;
  // Remove non-numeric characters
  value = value.replace(/[^0-9]/g, '');
  // Limit to 2 digits
  value = value.slice(0, 2);
  // Update input field instantly
  event.target.value = value;
  return value;
}
}
